import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  isAuthenticated: false,
  comingFrom: "",
  redirto: "",
};

export const UserSlice = createSlice({
  name: "UserSlice",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    setComingFrom: (state, action) => {
      state.comingFrom = action.payload;
    },
    setRedirTo: (state, action) => {
      state.redirto = action.payload;
    },
    clearAuthStorage: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.comingFrom = "";
    },
  },
});

export const { loginSuccess, clearAuthStorage, setComingFrom, setRedirTo } =
  UserSlice.actions;
export default UserSlice.reducer;
